<ion-button
  class="mcm-button {{ extraClasses() }}"
  [class.disabled]="disabled()"
  [class.is-active]="isActive()"
  [disabled]="disabled()"
  [color]="color()"
  [expand]="expand()"
  dataId="qa"
  [mcmDataAttr]="{ id: qaId() }"
  (click)="onHandleClick()">
  {{ text() | translate }}

  @if (icon()) {
    <ion-icon
      [icon]="icon()"
      [size]="iconSize()" />
  }
</ion-button>
